import { ObservableResult } from '../../models/result.model';
import { ActionDataService } from './data.service';
import {
  ComposerOfferOrOrder, CustomAddress,
  IActionResponse, IBrokeringTarget, IBrokeringTargetsResponse, IActionStudioSearchResult,
  IActionTypes,
  IFrowardUsers, IGetAppointments, LeadAction,
  NotInterestedDetail, NotInterestedTypes, PlaceInOrder
} from '../../models/action.model';
import { AppointmentExtProp, OfferExtProp, SelectedComposerOffers } from '../../models/leads/leads.model';
import { IFileDocument } from '../../models/shared.model';

export class MockActionDataService implements ActionDataService {

  actionResponse: IActionResponse = {
    LeadAccessible: true,
  };

  studioSearchResult: IActionStudioSearchResult[] = [{
    Id: 1687,
    Name: "Studio Gamma",
    Address: {
      Address: "789 Innovation Way",
      City: "Munich",
      ZipCode: "80331",
      Country: "Germany",
      CountryCode: "DE",
      Phone: "+49 89 12345678"
    },
    AreaManager: {
      Id: 4,
      FirstName: "Clara",
      LastName: "Schmidt",
      Email: "clara.schmidt@example.com",
      Login: "cschmidt",
      Phone: "+49 89 23456789",
      Mobile: "+49 171 2345678",
      Available: true,
      LanguageCode: "de",
      EnableReporting: true,
      Inactive: false,
      Organisation: "Sales",
      LeadMailEnabled: true,
      NotificationsEnabled: true,
      AppointmentMailEnabled: true,
      ExternalMailCCEnabled: false,
      CompletedMailEnabled: true,
      Gender: "Female"
    },
    ContactManagers: [
      {
        Id: 5,
        FirstName: "Lukas",
        LastName: "Weber",
        Email: "lukas.weber@example.com",
        Login: "lweber",
        Phone: "+49 89 34567890",
        Mobile: "+49 171 3456789",
        Available: false,
        LanguageCode: "de",
        EnableReporting: false,
        Inactive: false,
        Organisation: "Customer Care",
        LeadMailEnabled: false,
        NotificationsEnabled: true,
        AppointmentMailEnabled: false,
        ExternalMailCCEnabled: true,
        CompletedMailEnabled: false,
        Gender: "Male"
      }
    ],
    Email: "info@studiogamma.de",
    InternalForwardAvailable: true,
    Phone: "+49 89 12345678",
    KKZ: "S003"
  }];

  brokeringTargets: IBrokeringTarget[] = [
    {
      Id: 1,
      KKZ: '1ABC',
      Name: 'Testfirma GmbH',
      Email: 'info@testfirma-abc.example',
      IsoLang: 'de',
      LogoUrl: 'assets/icons/finstral-contacts.svg',
      MandantName: 'Testfirma GmbH',
      MandantKKZ: '1ABC',
      Distance: 1235,
      IsNewCustomer: true,
      IncludedInFirstWave: true,
      Address: {
        Address: 'Teststraße 1',
        AddressExt: 'Showroom Süd',
        ZipCode: '39100',
        City: 'Bozen',
        CountryText: 'Italien',
        CountryCode: 'IT',
        Email: 'info@testfirma-abc.example',
        Phone: '0471 123456',
        PhonePrefix: '+39',
        Website: 'www.testfirma-abc.example',
      },
      ContactManager: {
        Id: 5,
        FirstName: 'Mustermann',
        LastName: 'Max',
        Email: 'max.mustermann@example.com',
        Login: 'mmustermann',
        Phone: '',
        Mobile: '',
        Available: true,
        LanguageCode: 'de',
        EnableReporting: false,
        Inactive: false,
        Organisation: 'Kontaktmanager 1ABC',
        LeadMailEnabled: true,
        NotificationsEnabled: true,
        AppointmentMailEnabled: true,
        ExternalMailCCEnabled: false,
        CompletedMailEnabled: true,
        Gender: 'Male',
      },
    },
    {
      Id: 2,
      KKZ: '1XYZ',
      Name: 'Testfirma AG',
      Email: 'office@testfirma-xyz.example',
      IsoLang: 'de',
      LogoUrl: 'assets/icons/finstral-contacts.svg',
      MandantName: 'Testfirma AG',
      MandantKKZ: '1XYZ',
      Distance: 835,
      IsNewCustomer: false,
      IncludedInFirstWave: true,
      Address: {
        Address: 'Teststraße 84',
        ZipCode: '39100',
        City: 'Bozen',
        CountryText: 'Italien',
        CountryCode: 'IT',
        Email: 'office@testfirma-xyz.example',
        Phone: '0471 987654',
        PhonePrefix: '+39',
      },
      ContactManager: {
        Id: 6,
        FirstName: 'Simon',
        LastName: 'Müller',
        Email: 'simon.mueller@example.com',
        Login: 'smueller',
        Phone: '',
        Mobile: '',
        Available: true,
        LanguageCode: 'de',
        EnableReporting: false,
        Inactive: false,
        Organisation: 'Kontaktmanager 1XYZ',
        LeadMailEnabled: true,
        NotificationsEnabled: true,
        AppointmentMailEnabled: true,
        ExternalMailCCEnabled: false,
        CompletedMailEnabled: true,
        Gender: 'Male',
      },
    },
    {
      Id: 3,
      KKZ: '1LMN',
      Name: 'Testfirma Limited',
      Email: 'hello@testfirma-lmn.example',
      IsoLang: 'it',
      LogoUrl: 'assets/icons/finstral-contacts.svg',
      MandantName: 'Testfirma Limited',
      MandantKKZ: '1LMN',
      IsNewCustomer: false,
      IncludedInFirstWave: true,
      Address: {
        Address: 'Mustergasse 99',
        ZipCode: '39100',
        City: 'Bozen',
        CountryText: 'Italien',
        CountryCode: 'IT',
        Email: 'hello@testfirma-lmn.example',
        Mobile: '333 1234567',
        MobilePrefix: '+39',
      },
      ContactManager: {
        Id: 7,
        FirstName: 'Meier',
        LastName: 'Max',
        Email: 'max.meier@example.com',
        Login: 'mmeier',
        Phone: '',
        Mobile: '',
        Available: true,
        LanguageCode: 'it',
        EnableReporting: false,
        Inactive: false,
        Organisation: 'Kontaktmanager 1LMN',
        LeadMailEnabled: true,
        NotificationsEnabled: true,
        AppointmentMailEnabled: true,
        ExternalMailCCEnabled: false,
        CompletedMailEnabled: true,
        Gender: 'Male',
      },
    },
    {
      Id: 4,
      KKZ: '1OOO',
      Name: 'Testfirma & Co',
      Email: 'contact@testfirma-ooo.example',
      IsoLang: 'it',
      LogoUrl: 'assets/icons/finstral-contacts.svg',
      MandantName: 'Testfirma & Co',
      MandantKKZ: '1OOO',
      Distance: 1500,
      IsNewCustomer: true,
      IncludedInFirstWave: false,
      Address: {
        Address: 'Gastererweg 1',
        ZipCode: '39054',
        City: 'Unterinn',
        CountryText: 'Italien',
        CountryCode: 'IT',
        Email: 'contact@testfirma-ooo.example',
        Phone: '0471 222333',
        PhonePrefix: '+39',
      },
      ContactManager: {
        Id: 8,
        FirstName: 'Signora',
        LastName: 'Maria',
        Email: 'maria.signora@example.com',
        Login: 'msignora',
        Phone: '',
        Mobile: '',
        Available: true,
        LanguageCode: 'it',
        EnableReporting: false,
        Inactive: false,
        Organisation: 'Kontaktmanager 1OOO',
        LeadMailEnabled: true,
        NotificationsEnabled: true,
        AppointmentMailEnabled: true,
        ExternalMailCCEnabled: false,
        CompletedMailEnabled: true,
        Gender: 'Female',
      },
    },
    {
      Id: 5,
      KKZ: '1ZZZ',
      Name: 'Testfirma',
      Email: 'info@testfirma-zzz.example',
      IsoLang: 'de',
      LogoUrl: 'assets/icons/finstral-contacts.svg',
      MandantName: 'Testfirma',
      MandantKKZ: '1ZZZ',
      Distance: 2750,
      IsNewCustomer: true,
      IncludedInFirstWave: false,
      Address: {
        Address: 'Kaltererstr. 10',
        ZipCode: '39054',
        City: 'Kaltern',
        CountryText: 'Italien',
        CountryCode: 'IT',
        Email: 'info@testfirma-zzz.example',
        Phone: '0471 444555',
        PhonePrefix: '+39',
      },
      ContactManager: {
        Id: 9,
        FirstName: 'Testname',
        LastName: 'Lara',
        Email: 'lara.testname@example.com',
        Login: 'ltestname',
        Phone: '',
        Mobile: '',
        Available: true,
        LanguageCode: 'de',
        EnableReporting: false,
        Inactive: false,
        Organisation: 'Kontaktmanager 1ZZZ',
        LeadMailEnabled: true,
        NotificationsEnabled: true,
        AppointmentMailEnabled: true,
        ExternalMailCCEnabled: false,
        CompletedMailEnabled: true,
        Gender: 'Female',
      },
    },
  ];

  actionTypes: IActionTypes[] = [
    {
      Id: 1,
      Name: "Installation",
      Description: "Standard installation at the customer site",
      IsLocation: true
    },
    {
      Id: 2,
      Name: "Remote Support",
      Description: "Support session conducted remotely",
      IsLocation: false
    }
  ];

  forwardUsers: IFrowardUsers = {
    ByArea: [
      {
        Id: 10,
        FirstName: "Emily",
        LastName: "Klein",
        Email: "emily.klein@example.com",
        Login: "eklein",
        Phone: "+49 30 1112223",
        Mobile: "+49 171 2223344",
        Available: true,
        LanguageCode: "de",
        EnableReporting: true,
        Inactive: false,
        Organisation: "Area Management",
        LeadMailEnabled: true,
        NotificationsEnabled: true,
        AppointmentMailEnabled: false,
        ExternalMailCCEnabled: false,
        CompletedMailEnabled: true,
        Gender: "Female"
      }
    ],
    ByHierarchy: [
      {
        Id: 11,
        FirstName: "Martin",
        LastName: "Fischer",
        Email: "martin.fischer@example.com",
        Login: "mfischer",
        Phone: "+49 89 3334445",
        Mobile: "+49 171 4455667",
        Available: false,
        LanguageCode: "de",
        EnableReporting: false,
        Inactive: false,
        Organisation: "Management",
        LeadMailEnabled: false,
        NotificationsEnabled: true,
        AppointmentMailEnabled: true,
        ExternalMailCCEnabled: true,
        CompletedMailEnabled: false,
        Gender: "Male"
      }
    ],
    UsersByArea: [
      {
        Id: 12,
        FirstName: "Sophie",
        LastName: "Bauer",
        Email: "sophie.bauer@example.com",
        Login: "sbauer",
        Phone: "+49 40 5556667",
        Mobile: "+49 171 6677889",
        Available: true,
        LanguageCode: "de",
        EnableReporting: true,
        Inactive: false,
        Organisation: "Sales",
        LeadMailEnabled: true,
        NotificationsEnabled: false,
        AppointmentMailEnabled: true,
        ExternalMailCCEnabled: false,
        CompletedMailEnabled: true,
        Gender: "Female"
      }
    ],
    UsersByHierarchy: [
      {
        Id: 13,
        FirstName: "Lena",
        LastName: "Schulz",
        Email: "lena.schulz@example.com",
        Login: "lschulz",
        Phone: "+49 211 7778889",
        Mobile: "+49 171 8899001",
        Available: false,
        LanguageCode: "de",
        EnableReporting: true,
        Inactive: false,
        Organisation: "Support",
        LeadMailEnabled: true,
        NotificationsEnabled: true,
        AppointmentMailEnabled: false,
        ExternalMailCCEnabled: true,
        CompletedMailEnabled: false,
        Gender: "Female"
      }
    ]
  };

  appointment: IGetAppointments = {
    LeadId: 101,
    Date: "2025-05-02T10:30:00Z",
    AppointmentTypeId: 3,
    AppointmentDescription: 12,
    length: 60
  };

  notInterestedDetails: NotInterestedDetail[] = [
    { Id: 10, NotInterestedTypeId: 21, Value: 'LESS10', Text: 'Weniger als 10%', Inactive: false, SortOrder: 1 },
    { Id: 7, NotInterestedTypeId: 21, Value: '10TO15', Text: '10% bis 15%', Inactive: false, SortOrder: 2 },
    { Id: 8, NotInterestedTypeId: 21, Value: '15TO30', Text: '15% bis 30%', Inactive: false, SortOrder: 3 },
    { Id: 9, NotInterestedTypeId: 21, Value: '30MORE', Text: 'mehr als 30%', Inactive: false, SortOrder: 4 },
  ];

  leadAction: LeadAction[] = [{
    Id: 1,
    Name: "Create Lead",
    Text: "Create a new lead record",
    RequiredRight: "LEAD_WRITE",
    RequiredTransitiveRight: "LEAD_MANAGE",
    SuccessStatusCode: 200,
    actionName: "LEAD_CREATE",
    AlternativeStatusCode: 400,
    SortOrder: 1
  }];

  getRejectTypes(): ObservableResult<IActionTypes[]> {
    return ObservableResult.ofSuccess(this.actionTypes);
  };

  getNotInterestedTypes(leadTypeId?: number): ObservableResult<NotInterestedTypes[] | IActionTypes[]> {
    return ObservableResult.ofSuccess(this.actionTypes);
  };

  getNotInterestedDetails(): ObservableResult<NotInterestedDetail[]> {
    return ObservableResult.ofSuccess(this.notInterestedDetails);
  };

  getAppointmentTypes(): ObservableResult<IActionTypes[]> {
    return ObservableResult.ofSuccess(this.actionTypes);
  };

  getForwardUsers( leadId: number, leadTypeId: number ): ObservableResult<IFrowardUsers> {
    return ObservableResult.ofSuccess(this.forwardUsers);
  };

  forwardRequest( leadId: number, comment: string, forwardUserId: number, forwardLeadTypeId: number, externalEmail: string ): ObservableResult<IActionResponse> {
    return ObservableResult.ofSuccess(this.actionResponse);
  }

  rejectRequest( leadId: number, comment: string, rejectReasonId: number ): ObservableResult<IActionResponse> {
    return ObservableResult.ofSuccess(this.actionResponse);
  };

  confirmRequest( leadId: number ): ObservableResult<IActionResponse> {
    return ObservableResult.ofSuccess(this.actionResponse);
  };

  completeRequest( leadId: number, comment: string, isExternal?: boolean ): ObservableResult<IActionResponse> {
    return ObservableResult.ofSuccess(this.actionResponse);
  };

  closeRequest( leadId: number, comment: string, notInterestedTypeId: number, notInterestedDetailId?: number ): ObservableResult<IActionResponse> {
    return ObservableResult.ofSuccess(this.actionResponse);
  };

  submitOffer( leadId: number,
               comment: string,
               appointmentTypeId: number,
               appointmentDate: Date,
               extendedProperties: OfferExtProp[] | OfferExtProp | SelectedComposerOffers,
               isComposerOffer: boolean,
               showroomTypeId?: string,
               isExternal?: boolean
  ): ObservableResult<IActionResponse> {
    return ObservableResult.ofSuccess(this.actionResponse);
  };

  submitComposerOfferOrder( leadId: number, data: ComposerOfferOrOrder ): ObservableResult<IActionResponse> {
    return ObservableResult.ofSuccess(this.actionResponse);
  };

  deleteComposerOfferOrder( leadId: number, offerId: number ): ObservableResult<IActionResponse> {
    return ObservableResult.ofSuccess(this.actionResponse);
  };

  composerOfferSetToMain( leadId: number, offerId: number ): ObservableResult<IActionResponse> {
    return ObservableResult.ofSuccess(this.actionResponse);
  };

  composerMultiOffersSetToMain( leadId: number, offerIds: number[] ): ObservableResult<IActionResponse> {
    return ObservableResult.ofSuccess(this.actionResponse);
  };

  undoAssignment( leadId: number, comment: string ): ObservableResult<IActionResponse> {
    return ObservableResult.ofSuccess(this.actionResponse);
  };

  reopenLead( leadId: number, comment: string ): ObservableResult<IActionResponse> {
    return ObservableResult.ofSuccess(this.actionResponse);
  };

  placeOrder( leadId: number, placeInOrder: PlaceInOrder, isExternal?: boolean ): ObservableResult<IActionResponse> {
    return ObservableResult.ofSuccess(this.actionResponse);
  };

  changeType( leadId: number, comment: string, leadTypeId: number ): ObservableResult<IActionResponse> {
    return ObservableResult.ofSuccess(this.actionResponse);
  };

  changeSource( leadId: number, leadSourceId: number ): ObservableResult<IActionResponse> {
    return ObservableResult.ofSuccess(this.actionResponse);
  };

  createAppointment(
    leadId: number,
    comment: string,
    appointmentTypeId: number,
    appointmentDate: Date,
    extendedProperties: AppointmentExtProp,
    showroomTypeId?: string,
    isExternal?: boolean
  ): ObservableResult<IActionResponse> {
    return ObservableResult.ofSuccess(this.actionResponse);
  };

  createConsultation(
    leadId: number,
    comment: string,
    appointmentTypeId: number,
    appointmentDate: Date,
    extendedProperties: AppointmentExtProp,
    showroomTypeId?: string,
    isExternal?: boolean
  ): ObservableResult<IActionResponse> {
    return ObservableResult.ofSuccess(this.actionResponse);
  };

  moveAppointment( leadId: number, comment: string, appointmentDate: Date ): ObservableResult<IActionResponse> {
    return ObservableResult.ofSuccess(this.actionResponse);
  };

  moveOffer( leadId: number, comment: string, appointmentDate: Date ): ObservableResult<IActionResponse> {
    return ObservableResult.ofSuccess(this.actionResponse);
  };

  visitPlanner( leadId: number, comment: string, appointmentDate: Date, appointmentTypeId: number, isPlanerVisitMove: boolean, isExternal: boolean, address?: CustomAddress ): ObservableResult<IActionResponse> {
    return ObservableResult.ofSuccess(this.actionResponse);
  };

  invitePlanner( leadId: number, comment: string, appointmentDate: Date, kkz: string, appointmentTypeId: number, isPlanerInviteMove: boolean, isExternal: boolean ): ObservableResult<IActionResponse> {
    return ObservableResult.ofSuccess(this.actionResponse);
  };

  compendiumAllow( leadId: number, comment: string ): ObservableResult<IActionResponse> {
    return ObservableResult.ofSuccess(this.actionResponse);
  };

  compendiumDeny( leadId: number, comment: string ): ObservableResult<IActionResponse> {
    return ObservableResult.ofSuccess(this.actionResponse);
  };

  leadBrokerAbort( leadId: number, comment: string ): ObservableResult<IActionResponse> {
    return ObservableResult.ofSuccess(this.actionResponse);
  };

  sendReminder( leadId: number, comment: string, appointmentDate: Date ): ObservableResult<IActionResponse> {
    return ObservableResult.ofSuccess(this.actionResponse);
  };

  sendExternalEmail( leadId: number, externalEmail: string ): ObservableResult<IActionResponse> {
    return ObservableResult.ofSuccess(this.actionResponse);
  };

  createComment( leadId: number, comment: string, attachments?: IFileDocument[] ): ObservableResult<IActionResponse> {
    return ObservableResult.ofSuccess(this.actionResponse);
  };

  delayOffer( leadId: number, comment: string, appointmentDate: Date ): ObservableResult<IActionResponse> {
    return ObservableResult.ofSuccess(this.actionResponse);
  };

  sendEmail( leadId: number, comment: string, externalEmail: string ): ObservableResult<IActionResponse> {
    return ObservableResult.ofSuccess(this.actionResponse);
  };

  getSnippets(): ObservableResult<LeadAction[]> {
    return ObservableResult.ofSuccess(this.leadAction);
  };

  sendKkz( leadId: number, comment: string, kkz: string, externalEmail: string ): ObservableResult<IActionResponse> {
    return ObservableResult.ofSuccess(this.actionResponse);
  };

  updateIsSharedStatus( leadId: number, isShared: boolean ): ObservableResult<IActionResponse> {
    return ObservableResult.ofSuccess(this.actionResponse);
  }

  getAppointments( userId: number ): ObservableResult<IGetAppointments> {
    return ObservableResult.ofSuccess(this.appointment);
  };

  createNegotiation(
    leadId: number,
    comment: string,
    appointmentTypeId: number,
    appointmentDate: Date,
    showroomTypeId?: string,
  ): ObservableResult<IActionResponse> {
    return ObservableResult.ofSuccess(this.actionResponse);
  };

  moveNegotiation( leadId: number, comment: string, appointmentDate: Date ): ObservableResult<IActionResponse> {
    return ObservableResult.ofSuccess(this.actionResponse);
  };

  leadTakeover( leadId: number, comment: string ): ObservableResult<IActionResponse> {
    return ObservableResult.ofSuccess(this.actionResponse);
  };

  studioSearch( searchText ): ObservableResult<IActionStudioSearchResult[]> {
    return ObservableResult.ofSuccess(this.studioSearchResult);
  };

  getBrokeringTargets( leadId: number ): ObservableResult<IBrokeringTargetsResponse> {
    return ObservableResult.ofSuccess({ BrokeringTargets: this.brokeringTargets });
  }

  startBrokering( leadId: number, maxAcceptedPartners: number, secondWaveDetailMinutes: number ): ObservableResult<IActionResponse> {
    return ObservableResult.ofSuccess(this.actionResponse);
  }

}
